module.exports = __webpack_public_path__ + "img/rlink.63b30724.svg";